import React, { useCallback } from "react";
import client from "@culturehq/client";

import { useFetch } from "app/hooks";

import DefaultPanel from "components/display/DefaultPanel";
import ErrorPage from "components/ErrorPage";
import NotFound from "components/NotFound";
import FeedItem from "components/feed/FeedItem";

const UserClaimedCallout = ({ match }) => {
  const { fetching, error, json: { usersClaimed }, onUpdate } = useFetch(
    () => client.getUserClaimed({ userId: match.params.userClaimedId }),
    [match.params.userClaimedId]
  );

  const onUserActivityUpdate = useCallback(
    (userActivityId, updates) => onUpdate({
      userClaimed: { ...usersClaimed, userActivity: { ...usersClaimed.userActivity, ...updates } }
    }),
    [onUpdate, usersClaimed]
  );

  const onUserActivityRemove = useCallback(
    () => onUpdate({ userClaimed: null }),
    [onUpdate]
  );

  if ((error && error.status === 404) || (!fetching && !usersClaimed)) {
    return <NotFound />;
  }

  if (error) {
    return <ErrorPage error={error} />;
  }

  if (fetching) {
    return <DefaultPanel className="max-width-900" />;
  }

  return (
    <div className="max-width-900">
      <FeedItem
        item={usersClaimed.userActivity}
        onUserActivityUpdate={onUserActivityUpdate}
        onUserActivityRemove={onUserActivityRemove}
      />
    </div>
  );
};

export default UserClaimedCallout;
